import React from "react";

export default function PlannerBadge({
  children,
  bg = "#f8fafc",
  border = "#e2e8f0",
  color = "#334155",
  size = "sm",
  uppercase = false,
  style = {},
}) {
  const sizes = {
    xs: {
      fontSize: 9,
      padding: "1px 6px",
    },
    sm: {
      fontSize: 10,
      padding: "2px 7px",
    },
    md: {
      fontSize: 11,
      padding: "4px 9px",
    },
  };

  const s = sizes[size] || sizes.sm;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 999,
        background: bg,
        border: `1px solid ${border}`,
        color,
        fontSize: s.fontSize,
        fontWeight: 900,
        padding: s.padding,
        textTransform: uppercase ? "uppercase" : "none",
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {children}
    </span>
  );
}